<template>
  <div class="button-block" :class="alignmentClass">

    
    <Button 
      v-if="shouldShowButton" 
      :to="buttonUrl"
    >
      {{ buttonText }}
    </Button>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import Button from '@/components/Button.vue'

const props = defineProps({
  block: {
    type: Object,
    required: true
  }
})

const shouldShowButton = computed(() => {
  // Only show if we have a valid link slug and display is not explicitly false
  const hasValidSlug = props.block.link?.slug && 
                      String(props.block.link.slug).trim() !== '' &&
                      String(props.block.link.slug).trim() !== 'undefined'
  
  const shouldDisplay = props.block.show?.display !== false
  
  // Console log for debugging
  console.log('ButtonBlock shouldShowButton check:', {
    hasValidSlug,
    shouldDisplay,
    linkSlug: props.block.link?.slug,
    showDisplay: props.block.show?.display,
    result: hasValidSlug && shouldDisplay
  })
  
  return hasValidSlug && shouldDisplay
})

const buttonText = computed(() => {
  const text = props.block.link?.text || 'Read More'
  console.log('ButtonBlock buttonText:', { 
    linkText: props.block.link?.text, 
    fallback: text 
  })
  return text
})

const buttonUrl = computed(() => {
  if (!props.block.link?.slug) return null
  
  const slug = String(props.block.link.slug).trim()
  const url = slug.startsWith('/') ? slug : `/${slug}`
  console.log('ButtonBlock buttonUrl:', { slug, url })
  return url
})

const alignmentClass = computed(() => {
  const align = props.block.align?.align || 'Auto'
  return {
    'button-block--left': align === 'Left',
    'button-block--right': align === 'Right',
    'button-block--auto': align === 'Auto'
  }
})
</script>

<style lang="scss" scoped>
.button-block {
  margin-top: 1rem;
  
  &--left {
    text-align: left;
  }
  
  &--right {
    text-align: right;
  }
  
  &--auto {
    text-align: center;
  }
  
  a {
    color: var(--theme-text) !important;
    text-decoration: none !important;
  }
}
</style> 

